import React from "react";
import Context from "../../../Context";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import SpecItem from "./SpecItem";
import SpecTree from "./SpecTree";
import PerfectScrollbar from "react-perfect-scrollbar";
import Scrollpane from "../../Misc/Scrollpane";
export default class Spec extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      customListKey: "",
      rights: {},
    };
  }
  componentDidMount() {
    this.assignRights();
  }

  componentDidUpdate() {
    this.renderButtons();
  }
  assignRights = () => {
    this.setState(
      {
        rights: {
          manage: true,
        },
      },
      () => this.renderButtons()
    );
  };
  onAfterElementSave = () => {
    this.setState({ customListKey: this.context.key() });
  };
  renderButtons = () => {
    const { shipId, projectId, itemId } = this.props;

    let showAddButton = this.state.rights.manage && projectId;

    this.context.actionsSet(
      <>
        {showAddButton && (
          <div
            onClick={() =>
              this.context.redirect(
                `/spec/${projectId}/${shipId}/add/${
                  itemId && itemId !== "add" ? "?node=" + itemId : ""
                }`
              )
            }
            title="Добавить"
            className={`btn ${
              this.state.mode === "add" ? "btn-light-primary" : "btn-light"
            } p-2  mr-2`}
          >
            <span className="flaticon2-add-1 px-2 align-middle"></span>
          </div>
        )}
      </>
    );
  };

  render() {
    const { shipId } = this.props;
    return (
      <>
        {shipId && shipId !== this.context.api.nullUuid && (
          <CrumbsProvider
            title="Структура СТСиК"
            link={`/element/${shipId}/`}
          />
        )}
        <CrumbsProvider title="Спецификация" link="/spec/" />
        <div className="row h-100">
          <div className="col-lg-6 border-right no-print">
            <Scrollpane>
              <SpecTree
                customListKey={this.state.customListKey}
                {...this.props}
              />
            </Scrollpane>
          </div>
          <div className="col h-100">
            <Scrollpane>
              <SpecItem
                onAfterSave={this.onAfterElementSave}
                {...this.props}
                {...this.state.rights}
              />
            </Scrollpane>
          </div>
        </div>
      </>
    );
  }
}
